
import { cn } from "@/lib/utils";

interface LoadingAnimationProps {
  className?: string;
}

const LoadingAnimation = ({ className }: LoadingAnimationProps) => {
  return (
    <div className={cn("flex flex-col items-center justify-center p-8", className)}>
      <div className="relative h-20 w-20">
        <div className="absolute inset-0 rounded-full border-8 border-t-pokemon-red border-r-pokemon-blue border-b-pokemon-yellow border-l-pokemon-red animate-spin-slow"></div>
        <div className="absolute inset-2 bg-white rounded-full flex items-center justify-center">
          <div className="h-4 w-4 rounded-full bg-gray-300 border-2 border-gray-400"></div>
        </div>
      </div>
      <p className="mt-4 text-lg font-medium">Catching Pokémon...</p>
    </div>
  );
};

export default LoadingAnimation;
